import { createRoutine } from 'redux-saga-routines'

export const SET = 'HOME/SET'
export const CONTENT = createRoutine('HOME/CONTENT')
